import React from 'react'
import config from './model/configModel'
import componentModel from './model/componentModel'
import start from './start'
import wrapper from './metaEngine/wrapper'
import AppLoader from './appLoader'
import JsonModel from './store/JsonModel'
import actionBase from './commit/actionBase'

const loadApp = (appName) => {
  return <AppLoader appName={appName}/>
}

export {
  start,
  config,
  componentModel,
  wrapper,
  loadApp,
  JsonModel,
  actionBase
}


// WEBPACK FOOTER //
// ./src/wbap-core-commit/index.js